import React, { useState, useEffect } from 'react';

const Ranking = ({ fetchRanking }) => {
  const [ranking, setRanking] = useState([]); // Estado para almacenar el ranking

  useEffect(() => {
    const loadRanking = async () => {
      try {
        const data = await fetchRanking(); // Llamar a fetchRanking para obtener los datos
        console.log("Datos obtenidos del ranking:", data);  // Agregar el log aquí
        if (Array.isArray(data)) {
          setRanking(data); // Solo actualizar si los datos son un arreglo
        } else {
          console.error('El formato de los datos obtenidos no es válido', data);
          setRanking([]); // En caso de error, dejar el ranking vacío
        }
      } catch (error) {
        console.error('Error al obtener el ranking:', error);
        setRanking([]); // En caso de error, dejar el ranking vacío
      }
    };
    loadRanking();
  }, [fetchRanking]); 

  // Función para asignar un color de fondo según la posición
  const getRowBackgroundColor = (index) => {
    if (index === 0) return "gold"; // Primer lugar: amarillo (oro)
    if (index === 1) return "silver"; // Segundo lugar: plateado
    if (index === 2) return "#cd7f32"; // Tercer lugar: bronce
    return "transparent"; // Resto de las filas (sin color de fondo)
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-3">🏆 Ranking Blackjack</h2>
      <table className="table table-bordered table-striped text-center">
        <thead className="table-dark">
          <tr>
            <th>Posición</th>
            <th>Nombre</th>
            <th>Top Saldo</th>
          </tr>
        </thead>
        <tbody>
          {ranking.length > 0 ? (
            ranking.map((player, index) => (
              <tr key={player.id}>
                <td 
                style={{ backgroundColor: getRowBackgroundColor(index), borderColor: 'black', borderWidth: '1px' }}
                >
                    {index + 1}
                    </td>
                <td 
                style={{ backgroundColor: getRowBackgroundColor(index), borderColor: 'black', borderWidth: '1px' }}
                >
                    {player.name}
                    </td>
                <td 
                style={{ backgroundColor: getRowBackgroundColor(index), borderColor: 'black', borderWidth: '1px' }}
                >
                   $ {player.top_score ? player.top_score.toLocaleString() : 'N/A'}
                    </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No hay datos disponibles.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Ranking;



